import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';
import { PrivyProvider } from '@privy-io/react-auth';
import { bsc } from 'viem/chains';

const root = ReactDOM.createRoot(document.getElementById('root'));

// Fallback to hardcoded value if env variable is not available (production build issue)
const PRIVY_APP_ID = process.env.REACT_APP_PRIVY_APP_ID || 'cmgdkdqsj00q5ic0d3bnfs738';


if (!PRIVY_APP_ID) {
  console.error('CRITICAL: Privy App ID is not set!');
}

root.render(
  <PrivyProvider
    appId={PRIVY_APP_ID}
    config={{
      loginMethods: ['wallet'],
      appearance: {
        theme: 'light',
        accentColor: '#ef4444',
      },
      defaultChain: bsc,
      supportedChains: [bsc],
    }}
  >
    <App />
  </PrivyProvider>
);

